import styled from 'styled-components';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';
import media from 'styles/media';

const DropZoneBox = styled.div`
  border: ${props => props.theme.dropZoneBorder};
  background: ${props => (props.highLight ? props.theme.dropZoneBackgroundHighlight : props.theme.dropZoneBackground)};
  text-align: center;
  padding: 20px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const Text = styled.p`
  ${media.extraSmallAndBelow`
    margin: 0;
  `}
`;

const TextLargeScreenOnly = styled.span`
  ${media.extraSmallAndBelow`
    display: none;
  `}
`;

DropZoneBox.HiddenFileInput = HiddenFileInput;
DropZoneBox.AddPhotosButton = SecondaryButton;
DropZoneBox.Text = Text;
DropZoneBox.TextLargeScreenOnly = TextLargeScreenOnly;

export default DropZoneBox;
